import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputStar from './InputStar';
import style from './style.scss';

const DrawerStars = ({validateForm, validateInput, _getStarsValid}) => {
    const [clicked, setClicked] = useState([false, false, false, false, false]);
    
    let stars = [];
    let maxStar = 5;

    for(let i = 1; i <= maxStar; i++) {
        stars.push(<label className={'drawer-stars-icon jumbo-icon-star ' + (i <= clicked ? ' active' : '')} key={i} htmlFor={'radio' + i}></label>);
    }
  
    const handleStarClick = (e, index) => {
        setClicked(index);
        e.preventDefault();  
    };

    return (  
        <form className='drawer-stars'>
            {stars.map((elem, i) => {
                return (
                    <InputStar key={i} elem={elem} index={i + 1} handleStarClick={handleStarClick} validateForm={validateForm} validateInput={validateInput} _getStarsValid={_getStarsValid}/>
                )}
            )}
        </form>
    )
}

DrawerStars.propTypes = {
    validateForm: PropTypes.func,
    validateInput: PropTypes.func,
    _getStarsValid: PropTypes.func
}

export default DrawerStars;